import { useShallow } from "zustand/react/shallow";

import { Divider } from "antd";
import styled from "styled-components/macro";

import { useLengthConversion } from "hooks/useUnitConversion";

import { LabeledSwitch } from "components/base";
import { useXdaSettingsStore } from "components/vis/context";
import { selectXdaSettings } from "components/vis/context/xdaSettingsSelectors";

import { XdaOptionsWrapper } from "./XdaOptionsLayout";

function XdaGridOptions() {
  const settings = useXdaSettingsStore(useShallow(selectXdaSettings));
  const setXdaSettings = useXdaSettingsStore((s) => s.setXdaSettings);
  const { showRelativeDepth, showTVDSSDepth, showGrid } = settings;

  const { getDisplayUnit } = useLengthConversion();
  const targetUnit = getDisplayUnit();

  const handleSettingChange = (key) => (value) => {
    const nextSettings = { ...settings, [key]: value };
    setXdaSettings(nextSettings);
  };

  return (
    <XdaOptionsWrapper overflowY="none">
      <SectionHeader>X-Axis</SectionHeader>
      <LabeledSwitch
        testId="xda-lineDistance"
        label={{
          value: `Line Distance (${targetUnit})`
        }}
        switch={{
          isChecked: showGrid,
          onChange: handleSettingChange("showGrid")
        }}
      />
      <AxesDivider />
      <SectionHeader>Y-Axis</SectionHeader>
      <LabeledSwitch
        testId="xda-relativeDepth"
        label={{ value: `Relative Depth (${targetUnit})` }}
        switch={{
          isChecked: showRelativeDepth,
          onChange: handleSettingChange("showRelativeDepth")
        }}
      />
      <LabeledSwitch
        testId="xda-tvdssDepth"
        label={{ value: `TVD SS (${targetUnit})` }}
        switch={{
          isChecked: showTVDSSDepth,
          onChange: handleSettingChange("showTVDSSDepth")
        }}
      />
    </XdaOptionsWrapper>
  );
}

export default XdaGridOptions;

const AxesDivider = styled(Divider)`
  margin: 10px 0;
`;

const SectionHeader = styled.div`
  font-weight: bold;
`;
